import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch } from "react-redux";
import { setCurrentHub } from "redux/CurrentHub/CurrentHubReducer";
import { getUserInfo } from "redux/userInfo/userInfoReducer";
import { filterDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export default function useSetPermissionRoutesDispatches() {
  const dispatch = useDispatch();
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated || auth.isLoading) {
      return;
    }

    filterDataAPI(
      filterUrls.fetchPermissionsByUserName,
      { in: "" },
      true,
      false
    )
      .then((res) => {
        const perms = res.data.permissionArray
          .map(({ permission }: any) => permission)
          .flat(1);

        localStorage.setItem(
          "currenthub",
          JSON.stringify(res.data.currenthub)
        );

        localStorage.setItem(
          "hublist",
          JSON.stringify(res.data.hublist)
        );

        dispatch(getUserInfo({ ...res.data, perms }));
        dispatch(setCurrentHub(res.data.currenthub));
      })
      .catch(() => {
        // interceptor handles authentication errors
      });
  }, [auth.isAuthenticated, auth.isLoading, dispatch]);

  return {};
}